var generic = window.generic || {};
var randomPrize = window.randomPrize || {};

(function ($) {
  Drupal.behaviors.spinGameV1 = {
    attach: function (context) {
      // Properties
      var isSpinning = false;
      var currentTry = 0;
      var chanceOfWinning = 100;
      // Corresponds to animation duration defined in SCSS.
      var wheelSpinDuration = 5000;
      var offerAngle = 0;
      var totalTries = parseInt($('.js-no_of_tries').val(), 10) || 3;
      var offerCodes = $('.js-offer_codes').val();
      var offerArray = $.map(offerCodes.split(','), $.trim);
      var $spinGameContainer = $('.js-spin-game-v1', context);
      var $spinGamePlayLanding = $('.js-game-landing', context);
      var $spinGamePlayTerms = $('.js-spin-game-terms-conditions', context);
      var $playNowBtn = $('.js-spin-game-play-now', $spinGameContainer);
      var $addToBagBtn = $('.js-apply-offer', $spinGameContainer);
      var $playAgain = $('.js-spin-game-play-again', $spinGameContainer);
      var $prizeInstruction = $('.js-spin-game-prize-instruction', $spinGameContainer);
      var $prizeContent = $('.js-spin-game-prize-content', $spinGameContainer);
      var $spinWheelWrapper = $('.js-spin-game-wheel-wrapper', $spinGameContainer);
      var $winningOfferImage = $('.js-spin-game-prize-image', $spinGameContainer);
      var $remainingSpinsContainer = $('.js-spin-game-remaining-spins', $spinGameContainer);
      var $winModel = $('.js-spin-game-win-modal', $spinGameContainer);
      var $offerAppliedModel = $('.js-spin-game-offer-applied-modal', $spinGameContainer);
      var $offerAppliedText = $('.js-spin-game-offer-applied-text', $spinGameContainer);
      var $tryAgainModel = $('.js-spin-game-try-again-modal', $spinGameContainer);
      var $outOfSpinsModel = $('.js-spin-game-out-of-spins-modal', $spinGameContainer);
      var $offerAppliedModelSpinsLeft = $('.js-spin-game-spins-left', $spinGameContainer);
      var spinOptions = {
        slices: 8,
        oneSpin: 360,
        // No. of times to go round.
        spins: 3,
        // Degrees to spin to try again slice.
        tryAgain: $spinGameContainer.data('try-again-slice-angle') || 90
      };

      /**
       * Split delimited field from drupal. This assumes that the delimiter
       * is ^===^.
       *
       * @param {string} text - The string to split
       * @returns {Array} the split fields
       */
      function splitField(text) {
        var fields = [];
        var trimmedText;

        if (!text) {
          return [];
        }
        trimmedText = $.trim(text);
        if (trimmedText.length) {
          fields = trimmedText.split('^===^');
        }

        return fields;
      }

      /**
       * Hide jquery object by adding the "hidden" class.
       *
       * @param {Object} $obj - The jquery object.
       * @returns {boolean} false
       */
      function hide($obj) {
        $obj.addClass('hidden');
      }

      /**
       * Show jquery object by removing the "hidden" class.
       *
       * @param {Object} $obj - The jquery object.
       * @returns {boolean} false
       */
      function unhide($obj) {
        $obj.removeClass('hidden');
      }

      /**
       * Returns the game_offer_applied cookie.
       *
       * @returns {string} The game_offer_applied cookie
       */
      function getOfferAppliedCookie() {
        return randomPrize.getCookie('game_offer_applied') || randomPrize.hasOfferInCart();
      }

      /**
       * Return the winning offer code.
       *
       * @returns {string} The winning offer code
       */
      function getWinningOfferCode() {
        var offerCode;
        var winningOfferInfo = randomPrize.getWinningOffer();

        if (winningOfferInfo.winningOffer) {
          offerCode = winningOfferInfo.winningOffer.offer_code;
        }

        return offerCode;
      }

      /**
       * Calculate the spin wheel's resulting position.
       *
       * @param {boolean} willWin - The chance of Winning.
       * @returns {boolean} false
       */
      function calcSpinResultPosition(willWin) {
        var winningOfferCode;
        var winningSlice;
        var offerAngles = splitField(
          $('.js-spin-game-offer-slice-angles', $spinGameContainer).html()
        );
        var spinsPlayed = randomPrize.getNumberOfTriesCookie();
        var fullSpins = spinOptions.oneSpin * spinOptions.spins * spinsPlayed;

        if (willWin) {
          winningOfferCode = getWinningOfferCode();
          winningSlice = offerArray.indexOf(winningOfferCode);

          offerAngle = fullSpins + parseInt(offerAngles[winningSlice], 10);
        } else {
          offerAngle = spinOptions.tryAgain + (fullSpins - spinOptions.oneSpin);
        }
      }

      /**
       * Calculate the number of spins left.
       *
       * @returns {number} The number of remaining spins.
       */
      function calcSpinsLeft() {
        var spinsLeft = totalTries - currentTry;

        if (getOfferAppliedCookie()) {
          return 0;
        }
        if (spinsLeft < 0) {
          spinsLeft = 0;
        }

        return spinsLeft;
      }

      /**
       * Update the remaining spins page elements.
       *
       * @param {number} spinsLeft - The number of spins left
       * @returns {boolean} false
       */
      function updateRemainingSpins(spinsLeft) {
        var msgName = spinsLeft === 1 ? 'spins-remaining-singular' : 'spins-remaining-plural';
        var remainingSpinsMsg = $remainingSpinsContainer.data(msgName);
        var $remainingSpinsMsgContainer = $(
          '.js-spin-game-remaining-spins-msg',
          $remainingSpinsContainer
        );
        var $remainingSpinsMsgCount = $(
          '.js-spin-game-remaining-spins-count',
          $remainingSpinsMsgContainer
        );
        var $remainingSpinsMsgTxt = $(
          '.js-spin-game-remaining-spins-txt',
          $remainingSpinsMsgContainer
        );
        var $remainingSpinsCircle = $('.js-spin-circle', $remainingSpinsContainer);
        var $remainingSpinsBackgroundColor = $('.js-spin-circle', $remainingSpinsContainer).attr(
          'data-background-color'
        );
        if (remainingSpinsMsg && remainingSpinsMsg.length) {
          $remainingSpinsMsgTxt.html(remainingSpinsMsg);
          $remainingSpinsMsgCount.html(spinsLeft);
        }
        if ($remainingSpinsBackgroundColor) {
          $remainingSpinsCircle.css('background', $remainingSpinsBackgroundColor);
        } else {
          $remainingSpinsCircle.addClass('filled');
        }
        $remainingSpinsCircle.each(function (index) {
          if (index < currentTry) {
            $(this).css('background', 'none');
          }
        });
      }

      /**
       * Update the dynamic elements of the page.
       *
       * @returns {boolean} false
       */
      function updatePage() {
        var spinsLeft = calcSpinsLeft();

        updateRemainingSpins(spinsLeft);
      }

      /**
       * Update the page contents for the winning offer.
       *
       * @returns {boolean} false
       */
      function updateWinningOffer() {
        var offerTitles = splitField($('.js-spin-game-offer-titles', $spinGameContainer).html());
        var offerDescriptions = splitField(
          $('.js-spin-game-offer-descriptions', $spinGameContainer).html()
        );
        var offerImages = splitField($spinGameContainer.data('spin-game-offer-images'));
        var offerImagesAlt = splitField($spinGameContainer.data('spin-game-offer-images-alt'));
        var $header = $('.js-spin-game-prize-header', $spinGameContainer);
        var $headerMob = $('.js-spin-game-prize-header-mobile', $spinGameContainer);
        var $subHeader = $('.js-spin-game-prize-sub-header', $spinGameContainer);
        var index = 0;
        var winningOfferCode = getWinningOfferCode();

        index = offerArray.indexOf(winningOfferCode);

        // Inject winning offer info
        if (offerTitles.length) {
          $header.html(offerTitles[index]);
          $headerMob.html(offerTitles[index]);
        }
        if (offerDescriptions.length) {
          $subHeader.html(offerDescriptions[index]);
        }
        // Inject winning offer image
        if (offerImages.length) {
          $winningOfferImage.attr('src', offerImages[index]);
          if (offerImagesAlt[index]) {
            $winningOfferImage.attr('alt', offerImagesAlt[index]);
          }
        }
      }

      /**
       * Shows the prize popup.
       *
       * @returns {boolean} false
       */
      function showWinBox() {
        var offerInfo = randomPrize.getWinningOffer();
        var $remainingSpins = $remainingSpinsContainer.html();

        if (!offerInfo || !offerInfo.winningOffer) {
          return false;
        }
        if (!offerInfo.playAgain || calcSpinsLeft() === 0) {
          hide($playAgain);
          hide($prizeInstruction);
          hide($spinGamePlayTerms);
          $prizeContent.addClass('out-of-spins');
        }
        updateWinningOffer();
        $spinGameContainer.addClass('spin-game--prize-reveal');
        $offerAppliedModelSpinsLeft.html($remainingSpins);
        unhide($winModel);
        hide($spinGamePlayLanding);
      }

      /**
       * Show a Out of Spins Message.
       *
       * @returns {boolean} false
       */
      function showOutOfSpinsBox() {
        randomPrize.hidePopup();
        hide($spinGamePlayLanding);
        hide($spinGamePlayTerms);
        unhide($outOfSpinsModel);
      }

      /**
       * Show a Try again Message.
       *
       * @returns {boolean} false
       */
      function showTryAgainBox() {
        hide($spinGamePlayLanding);
        hide($spinGamePlayTerms);
        unhide($tryAgainModel);
      }

      /**
       * Show the result of the Spin Offer.
       *
       * @param {boolean} willWin - When true, show the prize.
       * @returns {boolean} false
       */
      function showResult(willWin) {
        var offerCode = getWinningOfferCode();

        isSpinning = false;
        // Have they won
        if (willWin && offerCode) {
          randomPrize.setWinningOfferCookie(offerCode);
          setTimeout(showWinBox(), 1000);
        } else {
          setTimeout(showTryAgainBox, 1000);
        }
        randomPrize.set24HourCookie(1);
      }

      /**
       * Play the game.
       *
       * @returns {boolean} false
       */
      function playGame() {
        var willWin;

        if (isSpinning) {
          return;
        }
        isSpinning = true;

        currentTry += 1;
        updatePage();
        randomPrize.setNumberOfTriesCookie(1);

        // Once play game / play again CTA is clicked, calculate new prize
        if (randomPrize.isGameValidforPlay()) {
          randomPrize.setNewPrize();
          randomPrize.getPrize();
        }

        // Okay now play the game.
        willWin = currentTry >= totalTries ? 1 : Math.round(Math.random() * 100) < chanceOfWinning;

        calcSpinResultPosition(willWin);
        $spinGameContainer.addClass('spin-game--spin-started');

        // Slight delay is required before we start rotating the wheel
        setTimeout(function () {
          $spinWheelWrapper.css({
            transform: 'rotate(' + offerAngle + 'deg)'
          });
        }, 100);

        setTimeout(function () {
          $spinWheelWrapper.css({
            transform: 'rotate(' + offerAngle + 'deg)'
          });

          showResult(willWin);
        }, wheelSpinDuration);
      }

      /**
       * Reset the spin wheel animations.
       *
       * @returns {boolean} false
       */
      function resetSpinWheel() {
        $spinGameContainer
          .addClass('spin-game--spin-reset')
          .removeClass('spin-game--spin-started spin-game--prize-reveal')
          .removeClass('spin-game--spin-started spin-game--fact-reveal');
        $spinWheelWrapper.css({ transform: 'rotate(0deg)' });
        $spinGameContainer.removeClass('spin-game--spin-reset');
        $winningOfferImage.attr('src', '');
      }

      /**
       * Reset the spin wheel and spin again.
       *
       * @returns {boolean} false
       */
      function resetAndPlayGame() {
        randomPrize.deleteWinningOfferCookie();
        resetSpinWheel();
        hide($winModel);
        hide($offerAppliedModel);
        hide($tryAgainModel);
        hide($outOfSpinsModel);
        unhide($spinGamePlayLanding);
        playGame();
      }

      /**
       * Show a Offer Applied Message.
       *
       * @returns {boolean} false
       */
      function showOfferAppliedBox() {
        var offerBenefits = splitField(
          $('.js-spin-game-offer-benefits', $spinGameContainer).html()
        );
        var offerSuccesText;
        var winningOfferCode = getWinningOfferCode();
        var index = offerArray.indexOf(winningOfferCode);

        generic.cookie('game_offer_applied', 1, 24);
        hide($spinGamePlayLanding);
        hide($spinGamePlayTerms);
        hide($winModel);
        if (offerBenefits.length) {
          offerSuccesText = $offerAppliedText.html();
          offerSuccesText = offerSuccesText.replace('::offer_benefit::', offerBenefits[index]);
          $offerAppliedText.html(offerSuccesText);
        }
        unhide($offerAppliedModel);
        randomPrize.stopLoading();
      }

      /**
       * Update the page on Load.
       *
       * @returns {boolean} false
       */
      function updatePageOnLoad() {
        var alreadyWonOffer = randomPrize.isAlreadyPlayed();
        var isOfferRedeemed = Boolean(getOfferAppliedCookie());

        updatePage();
        unhide($spinGamePlayLanding);
        unhide($spinGamePlayTerms);

        if (alreadyWonOffer && !isOfferRedeemed) {
          showWinBox();
        }
        if (isOfferRedeemed) {
          showOutOfSpinsBox();
        }
        randomPrize.stopLoading();
      }

      /**
       * Add the won Offer to cart
       *
       * @returns {boolean} false
       */
      function addOfferToCart() {
        randomPrize.getLoading();
        currentTry = totalTries;
        randomPrize.applyOffer(showOfferAppliedBox);
        updatePage();
      }

      /**
       * Initiate the randomizer game when this template loads.
       *
       * @returns {boolean} false
       */
      function initRandomPrize() {
        randomPrize.stopGameFor24HoursOnceWon = 0;
        randomPrize.getPrizeOnPageLoad = false;
        randomPrize.init(updatePageOnLoad);

        currentTry = randomPrize.getNumberOfTriesCookie()
          ? parseInt(randomPrize.getNumberOfTriesCookie(), 10)
          : 0;
        chanceOfWinning = randomPrize.getWinChance() || 100;
      }

      $addToBagBtn.on('click', addOfferToCart);

      $playNowBtn.on('click', resetAndPlayGame);

      $playAgain.on('click', resetAndPlayGame);

      $(document).on('randomPrize.game-unavailable', showOutOfSpinsBox);

      $('html, body').animate({ scrollTop: 0 }, 500);
      randomPrize.getLoading();
      initRandomPrize();
    }
  };
})(jQuery);
